export enum OTHER_COST_OWNERSHIP_TYPE {
  LOGISTIC = 'LOGISTIC',
  SUPPLIER = 'SUPPLIER',
  WAREHOUSE = 'WAREHOUSE',
  DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER',
  CARRIER = 'CARRIER',
}

export const OTHER_COST_OWNERSHIP_TYPE_VALUES = Object.values(OTHER_COST_OWNERSHIP_TYPE);

export const DEFAULT_OWNERSHIP_TYPES = [OTHER_COST_OWNERSHIP_TYPE.LOGISTIC, OTHER_COST_OWNERSHIP_TYPE.SUPPLIER];

export const OWNERSHIP_TYPES_MAP = {
  [OTHER_COST_OWNERSHIP_TYPE.LOGISTIC]: 'logistics',
  [OTHER_COST_OWNERSHIP_TYPE.SUPPLIER]: 'suppliers',
  [OTHER_COST_OWNERSHIP_TYPE.WAREHOUSE]: 'warehouse',
  [OTHER_COST_OWNERSHIP_TYPE.DISTRIBUTION_CENTER]: 'distribution-center',
  [OTHER_COST_OWNERSHIP_TYPE.CARRIER]: 'carrier',
};

export const PROVIDERS_TYPES_MAP: Record<string, string> = {
  LOGISTIC: 'logistics',
  SUPPLIER: 'suppliers',
  WAREHOUSE: 'warehouse',
  DISTRIBUTION_CENTER: 'distribution-center',
  CARRIER: 'carrier',
  DRIVER: 'drivers',
};

export const PROVIDERS_ROUTES_TYPES_MAP: Record<string, string> = {
  LOGISTIC: 'logistics',
  SUPPLIER: 'suppliers',
  WAREHOUSE: 'warehouses',
  DISTRIBUTION_CENTER: 'distribution-centers',
  CARRIER: 'carriers',
  DRIVER: 'drivers',
};
